import React, { useEffect, useState } from 'react'
import { useStoreState } from '../store'
import AmazonA from '@mortgage-pos/ui/assets/amazon-benefits.png'
import SageLogo from '@mortgage-pos/ui/assets/sageHomeLoansLogo.svg'

const enabledPages = [
  'purchaseStage',
  'incomeAndAssets',
  'createAccount',
  'pricing',
  'amazonPiiRequest',
]

const piiDisclosure =
  'We got your compensation information from Amazon to make the process as easy as possible. Please double check this is your most up-to-date information.'

function AmazonDemoHeader() {
  const { active } = useStoreState((state) => state.questionnaire)
  const [description, setDescription] = useState('')
  const [isCompact, setIsCompact] = useState(false)
  const [isCardVisible, setIsCardVisible] = useState(true)
  const [isValueVisible, setIsValueVisible] = useState(false)

  useEffect(() => {
    if (active.name === 'purchaseStage') {
      setIsCardVisible(true)
      setIsValueVisible(true)
      setIsCompact(false)
      setDescription(null)
    }

    if (active.name === 'createAccount') {
      setIsCardVisible(true)
      setIsValueVisible(false)
      setIsCompact(false)
      setDescription(piiDisclosure)
    }

    if (active.name === 'pricing') {
      setIsCardVisible(false)
      setIsValueVisible(true)
      setIsCompact(true)
      setDescription(null)
    }

    if (active.name === 'incomeAndAssets') {
      setIsCardVisible(true)
      setIsValueVisible(false)
      setIsCompact(false)
      setDescription(piiDisclosure)
    }

    if (active.name === 'amazonPiiRequest') {
      setIsCardVisible(false)
      setIsValueVisible(false)
      setIsCompact(true)
      setDescription(null)
    }
  }, [active.name])

  if (active.type !== 'page' || !enabledPages.includes(active.name)) return null

  const containerClasses = [
    'amazon-demo-header',
    !isCardVisible && 'amazon-demo-header--no-card',
    isCompact && 'amazon-demo-header--compact',
  ]
    .filter(Boolean)
    .join(' ')

  const logoClasses = [
    'amazon-demo-header__logos',
    isCompact && 'amazon-demo-header__logos--compact',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={containerClasses}>
      <div className="amazon-demo-header__content">
        <div className={logoClasses}>
          <img
            src={SageLogo}
            alt="Sage Logo"
            className="amazon-demo-header__sage-logo"
          />
          <span className="amazon-demo-header__plus">+</span>
          <img
            src={AmazonA}
            alt="Amazon Logo"
            className="amazon-demo-header__amazon-logo"
          />
        </div>

        {description && (
          <p className="amazon-demo-header__description">{description}</p>
        )}

        {isValueVisible && (
          <>
            {isCompact && <div className="amazon-demo-header__separator" />}
            <p className="amazon-demo-header__savings">
              You'll save{' '}
              <span className="amazon-demo-header__savings-amount">$750</span>{' '}
              at closing as an Amazon employee!
            </p>
          </>
        )}
      </div>
    </div>
  )
}

export default AmazonDemoHeader
